import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CardsViewModule } from '@barthauer/abc/cards-view';
import { BceComponent } from './bce.component';

@NgModule({
  imports: [CommonModule, CardsViewModule],
  declarations: [BceComponent],
  exports: [BceComponent],
})
export class BceModule {}
